/** Self-service booking API client — cookie auth. */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const ax = axios.create({ baseURL: BACKEND_URL, withCredentials: true });
const u = (p) => p.then((r) => r.data);

export const bookingApi = {
  // Tutor catalogue + availability
  listTutors:        (params)                        => u(ax.get('/api/booking/tutors', { params })),
  tutorAvailability: (tutorEmail, params)            => u(ax.get(`/api/booking/tutors/${encodeURIComponent(tutorEmail)}/availability`, { params })),

  // Tutor self-service availability
  myAvailability:    ()                              => u(ax.get('/api/booking/availability/me')),
  setMyAvailability: (body)                          => u(ax.put('/api/booking/availability/me', body)),

  // Student create + list
  createRequest:     (body)                          => u(ax.post('/api/booking/request', body)),
  myRequests:        (params)                        => u(ax.get('/api/booking/requests/me', { params })),

  // Tutor / admin respond
  respond:           (booking_id, body)              => u(ax.post(`/api/booking/requests/${booking_id}/respond`, body)),

  // Admin global
  adminRequests:     (params)                        => u(ax.get('/api/booking/admin/booking-requests', { params })),
};

export default bookingApi;
